module.exports = __webpack_public_path__ + "static/media/scenarios.7fd76983.svg";